<template>
  <div>
    <div class="menu" v-if="show">
      <ul>
        <li  v-for="menu in menuData" :key="menu.id" @click="toMenuLink(menu)">{{menu.name}}</li>
      </ul>
    </div>
    <div class="bannerMenu" v-else>手机菜单</div>
  </div>
</template>

<script>
  export default {
    name: "menus",
    props: {
      menuData: {
        type: Array,
        default: () => {
          return []
        }
      },
      show:{
        type: Boolean,
        default: true
      }
    },
    mounted(){
      console.log("menuData====",this.menuData)
      console.log("show====",this.show)
    },
    methods: {
      toMenuLink(menu) {
        this.$emit('toMenuLink',menu)
      },
    }
  }
</script>

<style scoped lang="less">
  .menu {
    height: 80px;
    line-height: 80px;
    background: #b6121b;

    ul {
      width: 1400px;
      margin: 0 auto;

      li {
        display: inline-block;
        margin: 0 30px;
        color: #FFFFFF;
        cursor: pointer;
        font-size: 18px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/menus.vue